<template>
  <div>
    <cube-form
      ref="form1"
      :model="model1"
      :schema="schema1"
      >
    </cube-form>
    <p class="case">如不能提供居民国（地区）纳税人识别号，请选择原因</p>
    <cube-form
      ref="formTemp"
      :model="modelTemp"
      :schema="schemaTemp"
      >
    </cube-form>
    <cube-form
      ref="form2"
      :model="model2"
      :schema="schema2"
      >
    </cube-form>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import { createToast } from '@/utils';

export default {
  name: 'TaxCommon',

  data() {
    return {
      model1: {
        taxAreaAndTaxpayerIdA: '', // 税收地区及纳税人识别号1
        taxAreaAndTaxpayerIdB: '', // 税收地区及纳税人识别号2
        taxAreaAndTaxpayerIdC: '', // 税收地区及纳税人识别号3
      },
      schema1: {
        groups: [
          {
            legend: '税收居民国（地区）及纳税人识别号',
            fields: [
              {
                type: 'input',
                modelKey: 'taxAreaAndTaxpayerIdA',
                label: '税号1',
                props: [{ placeholder: '请填写' }],
              },
              {
                type: 'input',
                modelKey: 'taxAreaAndTaxpayerIdB',
                label: '税号2',
                props: [{ placeholder: '请填写（如有）' }],
              },
              {
                type: 'input',
                modelKey: 'taxAreaAndTaxpayerIdC',
                label: '税号3',
                props: [{ placeholder: '请填写（如有）' }],
              },
            ],
          },

        ],
      },
      model2: {
        _taxNo: '', // 单选框: - 纳税人识别号
        canNotProvideTaxpayerIdNotAcquiredRemark: '', // 未取得纳税人识别号的备注说明
      },
      schema2: {
        fields: [],
      },
      modelTemp: {
        checkboxGroup: [], // 单选框: - 纳税人识别号
      },
      schemaTemp: {
        fields: [
          {
            // type: 'radio-group',
            type: 'checkbox-group',
            modelKey: 'checkboxGroup',
            events: { input: this.checkTaxNo },
            props: [{
              // class: 'radio-row',
              shape: 'square',
              options: [
                {
                  label: '居民国（地区）不发放纳税人识别号',
                  value: 'canNotProvideTaxpayerIdNotIssued',
                },
                {
                  label: '账户持有人未能取得纳税人识别号',
                  value: 'canNotProvideTaxpayerIdNotAcquired',
                },
              ],
            }],
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['tax']),
  },

  methods: {
    submit() {
      return new Promise(async (resolve, reject) => {
        const model = {};
        const {
          taxAreaAndTaxpayerIdA,
          taxAreaAndTaxpayerIdB,
          taxAreaAndTaxpayerIdC,
        } = this.model1;
        const {
          _taxNo,
          canNotProvideTaxpayerIdNotAcquiredRemark,
        } = this.model2;

        if (!(taxAreaAndTaxpayerIdA || taxAreaAndTaxpayerIdB || taxAreaAndTaxpayerIdC || _taxNo)) {
          createToast.call(this, '税号和原因不能全部为空');
          reject();
          return;
        }
        if ((taxAreaAndTaxpayerIdA || taxAreaAndTaxpayerIdB || taxAreaAndTaxpayerIdC) && _taxNo) {
          createToast.call(this, '税号和原因不能同时设置');
          reject();
          return;
        }
        if (_taxNo === 'canNotProvideTaxpayerIdNotAcquired' && !canNotProvideTaxpayerIdNotAcquiredRemark) {
          await this.$refs.form2.validate().then(value => (value === true ? Promise.resolve() : Promise.reject()));
        }
        if (_taxNo === 'canNotProvideTaxpayerIdNotIssued') {
          this.model2.canNotProvideTaxpayerIdNotAcquiredRemark = '';
        }
        if (_taxNo) {
          Object.assign(model, this.model2);
        }

        resolve(Object.assign(model, this.model1));
      });
    },
    checkTaxNo(checkeds) {
      if (checkeds.length > 1) {
        this.modelTemp.checkboxGroup.shift();
      }
      const value = this.modelTemp.checkboxGroup[0];
      this.model2._taxNo = value;
      const fields = this.schema2.fields.filter(field => field.modelKey !== 'canNotProvideTaxpayerIdNotAcquiredRemark');
      if (value === 'canNotProvideTaxpayerIdNotAcquired') {
        fields.push({
          modelKey: 'canNotProvideTaxpayerIdNotAcquiredRemark',
          type: 'input',
          label: '原因说明',
          props: [{ placeholder: '请解释具体原因' }],
          rules: {
            required: true,
          },
          messages: {
            required: '请填写原因',
          },
        });
      }
      this.schema2.fields = fields;
    },
  },

};
</script>

<style lang="scss" scoped>
.case {
  padding: 16px;
  font-size: 13px;
  color: #555;
  border-top: 7px solid #f5f5f5;
}
</style>
